import {FilterModel, MainModel} from './GenericModel';

export class UserLoginModel {
  username: string;
  password: string;
  grant_type: string;
  client_id: string;
  client_secret: string;
}

export class User extends MainModel {
  id: number;
  username: string;
  password: string;
  confirmPassword: string;
  name: string;
  surname: string;
  phone: string;
  email: string;
  active: boolean;
}

export class UserFilter extends FilterModel {
  username: string;
  name: string;
  surname: string;
  phone: string;
  email: string;
  active: Boolean;
  private _onlyActive: boolean;

  get onlyActive(): boolean {
    return this._onlyActive;
  }
  set onlyActive(onlyActive: boolean) {
    this._onlyActive = onlyActive;
    this.active = this._onlyActive ? true : null;
  }

}

export class CurrentUserModel {
  id: number;
  username: string;
}
